import { SEARCH_FIELD_TYPES } from '../../constants/advanced.search.constants';

export const DOSSIERS_ADVANCED_SEARCH_RESOURCE = {
  key: 'DOSSIERS_ADVANCED_SEARCH_RESOURCE',
  fields: [
    {
      name: 'name',
      label: 'Dossiernaam',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'general'
    },
    {
      name: 'dossierNumber',
      label: 'Dossiernr',
      type: SEARCH_FIELD_TYPES.TEXT,
      section: 'general'
    },
    {
      name: 'status',
      label: 'Status',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'statuses',
      section: 'general'
    },
    {
      name: 'type',
      label: 'Type',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'types',
      fieldProps: {
        disableSearch: true
      },
      section: 'general'
    },
    {
      name: 'theme',
      label: 'Label',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'themes',
      section: 'general'
    },
    {
      name: 'startDateFrom',
      label: 'Startdatum opvolging van',
      type: SEARCH_FIELD_TYPES.DATE,
      section: 'date'
    },
    {
      name: 'startDateTo',
      label: 'Startdatum opvolging tot',
      type: SEARCH_FIELD_TYPES.DATE,
      section: 'date',
      breakAfter: true
    },
    {
      name: 'deadlineFrom',
      label: 'Volgende deadline van',
      type: SEARCH_FIELD_TYPES.DATE,
      section: 'date'
    },
    {
      name: 'deadlineTo',
      label: 'Volgende deadline tot',
      type: SEARCH_FIELD_TYPES.DATE,
      section: 'date'
    },
    {
      name: 'school',
      label: 'School',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'schools',
      section: 'organization'
    },
    {
      name: 'branch',
      label: 'Vestiging',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'branches',
      section: 'organization'
    },
    {
      name: 'stakeholdersPartners',
      label: 'Betrokken partners',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'organizations',
      section: 'organization'
    },
    {
      name: 'requestedBy',
      label: 'Aangevraagd door',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'contacts',
      section: 'stakeholder'
    },
    {
      name: 'stakeholders',
      label: 'Betrokkenen',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'contacts',
      section: 'stakeholder'
    },
    {
      name: 'assigned',
      label: 'Toegewezen aan',
      type: SEARCH_FIELD_TYPES.MULTIPLE_SELECT,
      dependency: 'contacts',
      section: 'stakeholder'
    }
  ],
  sections: [
    { name: 'general', label: 'Algemeen' },
    { name: 'date', label: 'Datum' },
    { name: 'organization', label: 'Organisatie' },
    { name: 'stakeholder', label: 'Betrokkene' }
  ]
};
